/**
 * Generates a client-side idempotency key (L1 pattern): a random id stable
 * for the life of one logical request, so a double-click or a retry after a
 * timeout can be recognized as the same request server-side instead of
 * creating a second real result. First proven in create-class-overlay.tsx
 * for the April 2026 createClass incident (108 accounts provisioned for 45
 * kids on a retry); reused for generateQuestions per
 * docs/AUDIT-2026-09-23-lego-rewrite.md item #10.
 */
export const generateIdempotencyKey = (): string =>
	(typeof crypto !== 'undefined' && crypto.randomUUID)
		? crypto.randomUUID()
		: `req-${Date.now()}-${Math.random().toString(36).slice(2)}`
